module.exports = __webpack_public_path__ + "assets/37b292eb97687363ae873d81edb3c8f0.png";